/**
 * Delegated UI button click SFX — one listener on #app covers all <button> clicks.
 */
import { EventBus } from "./event-bus.js";

export function emitUiButtonClickSfx() {
  if (EventBus && typeof EventBus.emit === "function") {
    EventBus.emit("ui:button_click", {});
  }
}

/**
 * @param {EventTarget | null | undefined} target
 * @param {ParentNode} root
 * @returns {HTMLButtonElement | null}
 */
export function findUiClickSfxButton(target, root) {
  if (!target || !root || typeof target.closest !== "function") return null;
  var el = target.closest("button");
  if (!el || !root.contains(el)) return null;
  if (el.disabled || el.getAttribute("aria-disabled") === "true") return null;
  if (el.dataset.noClickSfx === "1") return null;
  return el;
}

/**
 * @param {Event | null | undefined} event
 * @param {ParentNode} root
 */
export function handleUiClickSfxEvent(event, root) {
  if (!event || !event.isTrusted) return;
  if (findUiClickSfxButton(event.target, root)) {
    emitUiButtonClickSfx();
  }
}

/**
 * @param {ParentNode | null | undefined} root
 */
export function installUiButtonClickSfx(root) {
  if (!root || root.dataset.uiClickSfxBound === "1") return;
  root.dataset.uiClickSfxBound = "1";
  root.addEventListener("click", function (e) {
    handleUiClickSfxEvent(e, root);
  }, true);
}
